import { ObstetricalResourcesDepressionScreening } from "@/Patient/Models/ObstetricalFile/Resources/ObstetricalResourcesDepressionScreening";
import { BaseObstetricalFileSubSection, BaseObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseObstetricalFileSubSection";
import { ObstetricalFileResourcesQuestionnaireTable } from "./ObstetricalFileResourcesQuestionnaireTable";

interface ObstetricalResourcesDepressionScreeningSectionProps<TForm> extends BaseObstetricalFileSubSectionProps<TForm> {
    model: ObstetricalResourcesDepressionScreening;
    mutateModel: (mutation: (state: ObstetricalResourcesDepressionScreening) => void) => void;
}

class ObstetricalResourcesDepressionScreeningSection<TForm> extends BaseObstetricalFileSubSection<TForm, ObstetricalResourcesDepressionScreeningSectionProps<TForm>, never> {
    public render(): JSX.Element {
        const depressionScreening = this.props.model;

        return (
            <div>
                <ObstetricalFileResourcesQuestionnaireTable
                    id="DepressionScreeningQuestionaire"
                    title="DepressionScreeningLabel"
                    subTitle="PatientHealthQuestionnairePhq2Label"
                    subTitleClassName="text-bold"
                    readonly={this.props.readonly}
                    date={depressionScreening.DepressionScreeningDate}
                    onDateChange={date => this.props.mutateModel(s => s.DepressionScreeningDate = date)}
                    columns={[
                        { label: "NotAtAllLabel", pointValue: 0 },
                        { label: "SeveralDaysLabel", pointValue: 1 },
                        { label: "MoreThanHalfTheDaysLabel", pointValue: 2 },
                        { label: "NearlyEveryDayLabel", pointValue: 3 }
                    ]}
                    questions={[
                        {
                            questionLabel: "LittleInterestOrPleasureInDoingThingsLabel",
                            onClick: value => this.props.mutateModel(s => s.DisinterestScore = value),
                            value: depressionScreening.DisinterestScore
                        },
                        {
                            questionLabel: "FeelingDownDepressedOrHopelessLabel",
                            onClick: value => this.props.mutateModel(s => s.DepressedScore = value),
                            value: depressionScreening.DepressedScore
                        }
                    ]}
                    totalScore={depressionScreening.TotalScore}
                    scoreDescription={{
                        titleLabel: "ObstetricalFile_TotalScoreOfThreeOrMoreWarrantsConsiderationLabel",
                        descriptionLabel: "ObstetricalFile_DepressionScreeningTotalScoreDescriptionLabel"
                    }}
                />
            </div>
        );
    }
}

export { ObstetricalResourcesDepressionScreeningSection, ObstetricalResourcesDepressionScreeningSectionProps };
